/* eslint-disable*/
import VueStoreService from './VueStoreService';
const ReportService = {
    async reportLocal(filter,store){
        var resp = await VueStoreService.get("api/store/listReport"+filter, store)
        return resp;
    },
    async reportProducts(filter,store){
        var resp = await VueStoreService.get("api/autopart/listReport"+filter, store)
        return resp;
    },
    async reportMasMenosVendidos(filter,store){
        var resp = await VueStoreService.get("api/store/listSellerReport"+filter, store)
        return resp;
    },
    async reportStock(filter,store){
        var resp = await VueStoreService.get("api/stock/listReport"+filter, store)
        return resp;
    },
    async reportStockExcel(filter,store){
        var resp = await VueStoreService.getFile("api/stock/exportReport"+filter, store)
        const headerContentDisp = resp.headers["content-disposition"];
        const filename =
          headerContentDisp &&
          headerContentDisp.split("filename=")[1].replace(/["']/g, ""); // TODO improve parcing
        const contentType = resp.headers["content-type"];
        console.log('filename',filename)
        const blob = new Blob([resp.data], { contentType });
        return blob
    },
    async reportAutoPartsExcel(filter,store){
        var resp = await VueStoreService.getFile("api/autopart/exportReport"+filter, store)
        const headerContentDisp = resp.headers["content-disposition"];
        const filename =
          headerContentDisp &&
          headerContentDisp.split("filename=")[1].replace(/["']/g, ""); // TODO improve parcing
        const contentType = resp.headers["content-type"];
        console.log('filename',filename)
        const blob = new Blob([resp.data], { contentType });
        return blob
    },
    async reportExportProducts(filter,store){
        var res = await VueStoreService.getFile("api/store/exportReportSellerLocal"+filter, store)
        console.log('res.data',res.data)
        const headerContentDisp = res.headers["content-disposition"];
        const filename =
          headerContentDisp &&
          headerContentDisp.split("filename=")[1].replace(/["']/g, ""); // TODO improve parcing
        const contentType = res.headers["content-type"];
        console.log('filename',filename)
        const blob = new Blob([res.data], { contentType });
        return blob
    },
    async reportExportLocal(filter,store){
        var resp = await VueStoreService.get("api/store/exportReportLocal"+filter, store)
        return resp;
    },
    async reportVentas(filter,store){
        var resp = await VueStoreService.get("api/external-movement/listSellerReport"+filter, store)
        return resp;
    },
}

export default ReportService;